import { Component, Input } from '@angular/core';
import {ClrDatagridModule, ClrDatagridSortOrder} from "@clr/angular";
import { AlertService, IAlertType, RequestsStoreService } from "../../../_shared/services";
import { Requests } from "../../../_shared/interfaces";
import {NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-request-card',
  standalone: true,
  imports: [
    NgIf,
    ClrDatagridModule,
    RouterLink
  ],
  templateUrl: './request-card.component.html',
  styleUrl: './request-card.component.sass'
})
export class RequestCardComponent {
  requests: Requests[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;

  @Input() companyId: number = 0;

  constructor(
    private reqss: RequestsStoreService,
    private alertDispatcher: AlertService,
  ) {}

  ngOnInit() {
    this.loading = true;
    this.loadList(this.companyId);
  }

  loadList(companyId: number) {
    this.reqss.getRequestsBySupplier(companyId).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.alertConfig.message = 'Keine Anfragen gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.requests = data.object;
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    });
  }

  splitProjectNumber(projectId: string, substring: number) {
    var splits = projectId.split('.');
    return splits[substring];
  }
}
